export default {
	URL: 'https://api-vetor.infinitum-ti.com',
	API_URL: 'https://api-vetor.infinitum-ti.com/api',
	OAPI_URL: 'https://api-vetor.infinitum-ti.com/oapi',
	// URL: 'http://localhost:2403',
	// API_URL: 'http://localhost:2403/api',
	// OAPI_URL: 'http://localhost:2403/oapi',
}
